import React from "react";
import { IMenuItem } from "@ui/components/Menu/IMenuItem";
import { Menu } from '@ui/components/Menu/menu';
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import useDictionary from '@ui/hooks/useDictionary';
import { IPropsMenu } from "./IProps";


const Component: React.FC<IPropsMenu> = ({
    id,
    onDeviceInfoOpen,
    onDeviceDescriptionOpen,
    onDeviceSettingsOpen,
    onDeviceBtnHoverStart,
    onDeviceBtnHoverStop
}: IPropsMenu) => {
    const getWord = useDictionary();
    let menuItems: IMenuItem[] = [
        {
            text: "infoAboutDevice",
            id: id,
            icon: <InfoIcon className="groups__item-menu-ico_item" />,
            onClick: onDeviceInfoOpen,
        },
        {
            text: "editDeviceDescription",
            id: id,
            icon: <EditIcon className="groups__item-menu-ico_item" />,
            onClick: onDeviceDescriptionOpen,
        },
    ];

    menuItems = [
        ...menuItems.slice(0, 2),
        {
            text: 'deviceSettings',
            id: id,
            icon: <SettingsIcon className="groups__item-menu-ico_item" />,
            onClick: onDeviceSettingsOpen,
        },
        ...menuItems.slice(2),
    ];

    const menuList = menuItems.map((item) => ({
        ...item,
        text: getWord(item.text),
    }));


    return (
        <>
            <Menu
                label="additionally"
                tooltip
                button={<MoreVertIcon className="groups__item-menu-ico" />}
                items={menuList}
                onHoverStart={onDeviceBtnHoverStart}
                onHoverStop={onDeviceBtnHoverStop}
            />
        </>
    );
};
const DeviceMenuHistory = React.memo(Component);

export default DeviceMenuHistory;
